// from `au.com.finsyn.util.entities.members.Membership`
export const BLANK_FUND: string = '****';
export const BLANK_MEMBER: string = '******';

/**
 * A representation of a "membership", that is, a member id and a fund ID.
 */
export interface Membership {
	fund: string;
	member: string;
}
